import React, {useEffect, useState} from 'react'
import {createCategory} from "../../services/serviceCategory";
import {AutoComplete, Button, Form, Input, Modal} from "antd";
import {getAllBrand} from "../../services/serviceBrand";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const { TextArea } = Input
const { Option } = AutoComplete
const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
}


const CategoryCreate = ({show, modalCloser, updater}) => {
    const [form] = Form.useForm()
    const [brands, setBrands] = useState([])
    const [createdBrand, setCreatedBrand] = useState('')
    const [loadings, setLoadings] = useState([])


    useEffect(() => {
        getAllBrand()
            .then(({data}) => {
                let brandsData = []
                data.forEach(item => {
                    let pushObj = {
                        value: item.id,
                        text: item.name
                    }
                    brandsData.push(pushObj)
                })
                setBrands(brandsData)
            })
    }, [])

    const handleBrandChange = (value, option) => {
        setCreatedBrand(option.key)
    }

    const handleSubmit = (list) => {
        enterLoadingState(setLoadings)

        let requestObj = {
            name: list.categoryName,
            code: list.categoryCode,
            brandId: createdBrand,
            description: list.categoryDescription
        }
        createCategory(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                modalCloser()
                updater()
            })
            .catch(() => exitLoadingState(setLoadings))
    }

    return (
        <React.Fragment>
            <Modal
                open={show}
                closable={false}
                title={'Yeni Kategori Ekle'}
                footer={[
                    <Button type={'primary'}
                            key={'SubmitButton'}
                            onClick={() => form.submit()}
                            loading={loadings[0]}
                    >Kaydet</Button>,
                    <Button  key={'CancelButton'} onClick={() => modalCloser()} >Kapat</Button>
                ]}
            >
                <Form
                    form={form}
                    {...formLayout}
                    onFinish={() => handleSubmit(form.getFieldsValue())}
                >

                    <Form.Item
                        label={'Kategori Adı'}
                        name={'categoryName'}
                        rules={[
                            {required:true, message: 'Kategori Adı Boş Bırakılamaz'},
                            {min: 5, max: 300, message: 'Kategori Adı En Az 5 En Fazla 300 Karakter Olabilir'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Kategori Kodu'}
                        name={'categoryCode'}
                        rules={[
                            {required: true, message: 'Kategori Kodu Boş Bırakılamaz'},
                            {pattern: /^\S*$/gm, message: 'Kategori Kodu Alanı Boşluk İçeremez'},
                            {min: 3, max: 20, message: 'Kategori Kodu En az 3 En Fazla 20 Karakter Olabilir'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Marka'}
                        name={'categoryBrand'}
                        rules={[
                            {required: true, message: 'Lütfen Bir Marka Seçiniz'}
                        ]}
                    >
                        <AutoComplete
                            onChange={handleBrandChange}
                            filterOption={(inputValue, option) =>
                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        >
                            {brands.map(({value, text}) => (
                                <Option key={value} value={text}>{text}</Option>
                            ))}
                        </AutoComplete>
                    </Form.Item>
                    <Form.Item
                        label={'Kategori Açıklaması'}
                        name={'categoryDescription'}
                    >
                        <TextArea />
                    </Form.Item>
                </Form>
            </Modal>
        </React.Fragment>
    )
}
export default CategoryCreate